import React from 'react';
import { differentiators } from '../data/content';
export function Differentiators() {
  return <section className="bg-ice px-3 py-4 sm:px-6" data-id="element-31" data-mp="1mcov2wbletnh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-32" data-mp="1mb3wmvm5qqkc">
        <h2 className="font-heading text-[1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.45rem]" data-id="element-33" data-mp="1r3naltorbnpo">
          This isn’t just another cleaning business ebook
        </h2>
        <p className="mt-0.5 font-heading text-[0.74rem] font-bold uppercase tracking-wide text-brightblue sm:text-[0.95rem]" data-id="element-34" data-mp="zd8zu6c1iri8">
          It’s a complete ready-to-use operating system.
        </p>
        <div className="mt-2 grid grid-cols-1 gap-1.5 text-left sm:grid-cols-2" data-id="element-35" data-mp="18cw6b6jmmni5">
          {differentiators.map(item => <div key={item.title} className="flex gap-2 rounded-md border border-navy/10 bg-white p-2 shadow-sm" data-id="element-36" data-mp="1ddbgxqcixgwf">
              <span className="text-lg leading-none" aria-hidden="true" data-id="element-37" data-mp="2orp3mrvjjqav">
                {item.emoji}
              </span>
              <div data-id="element-38" data-mp="bp3vtg1h8u7c">
                <h3 className="font-heading text-[0.78rem] font-bold leading-tight text-navy sm:text-[0.9rem]" data-id="element-39" data-mp="bnj37vyq3lc4">
                  {item.title}
                </h3>
                <p className="mt-0.5 text-[0.74rem] leading-[1.35] text-muted sm:text-[0.85rem]" data-id="element-40" data-mp="2nw27b9wohjl">
                  {item.body}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}